import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const LogisticsProblem = () => {
  const capabilities = [
    'Driver and dispatcher communication',
    'Safety awareness and procedural consistency',
    'Compliance readiness',
    'Incident response and escalation handling',
    'Onboarding speed and confidence',
    'Cross-team coordination',
    'Customer and shipper communication'
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            One Standard Across <span className="text-cyan-400">Every Mile</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto mb-8">
            In logistics and trucking, performance gaps don't show up on spreadsheets — they show up as delays, safety incidents, compliance risk, and customer dissatisfaction.
          </p>
          <p className="text-lg text-gray-400 max-w-4xl mx-auto">
            Traain provides the enablement infrastructure that keeps drivers, dispatch, operations, and support teams aligned — even in distributed, high-turnover environments.
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-12">
          <p className="text-xl font-bold text-white mb-6 text-center">With Traain, organizations strengthen:</p>
          <div className="grid md:grid-cols-2 gap-4">
            {capabilities.map((capability, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-5 rounded-xl bg-gradient-to-br from-gray-900/80 to-blue-900/20 border border-cyan-500/30 hover:border-cyan-400/60 transition-all duration-300"
              >
                <CheckCircle2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
                <p className="text-gray-300">{capability}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <div className="inline-block p-8 rounded-2xl bg-gradient-to-br from-cyan-900/20 to-blue-900/30 border border-cyan-500/30">
            <p className="text-xl text-white font-semibold">
              Traain brings clarity and consistency to complex, fast-moving operations.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogisticsProblem;
